export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";